// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import DropzoneController from './dropzone_controller'

import FlashController from './flash_controller'

import ModalController from './modal_controller'

import ClipboardController from './clipboard_controller'

import ThemeController from './theme_controller'

import LedgerFilterController from './ledger_filter_controller'

import RowLinkController from './row_link_controller'

application.register('dropzone', DropzoneController)
application.register('flash', FlashController)
application.register('modal', ModalController)
application.register('clipboard', ClipboardController)
application.register('theme', ThemeController)
application.register('ledger-filter', LedgerFilterController)
application.register('row-link', RowLinkController)
